"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _contentType = require("@insided/shared/utils/contentType");

var _Label = _interopRequireDefault(require("@insided/shared/uikit/Label"));

var _common = require("@insided/shared/utils/common");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicHeaderLabel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicHeaderLabel, _Component);

  var _super = _createSuper(TopicHeaderLabel);

  function TopicHeaderLabel() {
    (0, _classCallCheck2.default)(this, TopicHeaderLabel);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(TopicHeaderLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          topic = _this$props.topic,
          _this$props$usePlainT = _this$props.usePlainTextLabels,
          usePlainTextLabels = _this$props$usePlainT === void 0 ? false : _this$props$usePlainT,
          stickyOverride = _this$props.stickyOverride;
      var contentType = topic.contentType,
          publicLabel = topic.publicLabel,
          bestAnswer = topic.bestAnswer,
          ideaStatus = topic.ideaStatus,
          bugStatus = topic.bugStatus,
          closed = topic.closed,
          trashed = topic.trashed,
          spam = topic.spam,
          reported = topic.reported; // Use stickyOverride if provided, otherwise fall back to topic.sticky

      var sticky = stickyOverride !== null && stickyOverride !== void 0 ? stickyOverride : topic.sticky;
      var isIdeation = topic.contentType === _contentType.CONTENT_TYPE_IDEA;
      var isQuestion = contentType === _contentType.CONTENT_TYPE_QUESTION;
      var isArticleOrProductUpdate = contentType === _contentType.CONTENT_TYPE_ARTICLE || contentType === _contentType.CONTENT_TYPE_PRODUCT_UPDATE;
      var isConversation = contentType === _contentType.CONTENT_TYPE_CONVERSATION;

      var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

      var showBugStatus = isConversation && isBugContentTypeEnabled && bugStatus;
      return (0, _preact.h)("div", {
        className: "topic__labels-list"
      }, closed && usePlainTextLabels && (0, _preact.h)(_Label.default, {
        "data-qa": "closed_label",
        label: "Closed",
        variant: "danger"
      }), trashed && usePlainTextLabels && (0, _preact.h)(_Label.default, {
        "data-qa": "trash_label",
        label: "Trashed",
        variant: "neutral"
      }), spam && usePlainTextLabels && (0, _preact.h)(_Label.default, {
        "data-qa": "spam_label",
        label: "Spam",
        variant: "danger"
      }), reported && usePlainTextLabels && (0, _preact.h)(_Label.default, {
        "data-qa": "reported_label",
        label: "Reported",
        variant: "danger"
      }), sticky && (0, _preact.h)(_Label.default, {
        "data-qa": "sticky_label",
        label: (0, _preact.h)(_phrase.default, {
          p: "sticky"
        }),
        variant: "brand"
      }), isArticleOrProductUpdate && publicLabel && (0, _preact.h)(_Label.default, {
        "data-qa": "content_label",
        variant: "brand",
        label: publicLabel
      }), isQuestion && (0, _preact.h)(QuestionOrAnsweredLabel, {
        hasBestAnswer: !!bestAnswer,
        usePlainTextLabels: usePlainTextLabels
      }), isIdeation && ideaStatus && (0, _preact.h)(_Label.default, {
        "data-qa": "custom_label",
        variant: "custom",
        label: ideaStatus.name,
        style: {
          color: ideaStatus.textColor,
          backgroundColor: ideaStatus.backgroundColor
        }
      }), showBugStatus && (0, _preact.h)(_Label.default, {
        "data-qa": "bug_status_label",
        variant: "custom",
        label: bugStatus.name,
        style: {
          color: bugStatus.textColor,
          backgroundColor: bugStatus.backgroundColor
        }
      }));
    }
  }]);
  return TopicHeaderLabel;
}(_preact.Component);

var QuestionOrAnsweredLabel = function QuestionOrAnsweredLabel(_ref) {
  var hasBestAnswer = _ref.hasBestAnswer,
      _ref$usePlainTextLabe = _ref.usePlainTextLabels,
      usePlainTextLabels = _ref$usePlainTextLabe === void 0 ? false : _ref$usePlainTextLabe;

  if (hasBestAnswer) {
    return (0, _preact.h)(_Label.default, {
      "data-qa": "answer_label",
      label: usePlainTextLabels ? 'Answer' : (0, _preact.h)(_phrase.default, {
        p: "prefix.answer"
      }),
      variant: "success"
    });
  }

  return (0, _preact.h)(_Label.default, {
    "data-qa": "question_label",
    label: usePlainTextLabels ? 'Question' : (0, _preact.h)(_phrase.default, {
      p: "prefix.question"
    }),
    variant: "question"
  });
};

var _default = TopicHeaderLabel;
exports.default = _default;